import { extend, localize } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import en from "vee-validate/dist/locale/en.json";

console.log(required)

// Install rules
// Override the default message.
extend("required", {
  ...required,
  message: "This field is required"
});
extend("email", email);

extend("watch", {
  params: ["config"],
  computesRequired: true,
  validate: (value, { config }) => {
    if (!config || !(config || {}).conditions) return true;
    const [videoURL, percentageRequired, showTimeline] = config.conditions;
    const required = percentageRequired.value;
    if (isNaN(required) || Number(required) <= 0) return true;
    if (isNaN(value)) return false
    if (value < Number(required)) return false
    return true
  },
  message: (fieldName, placeholders) => {
    const [videoURL, percentageRequired, showTimeline] = placeholders.config.conditions;
    return `The video must be watched at least ${percentageRequired.value}%.`;
  }
});


extend('phonenumber', {
  params: ["config"],
  computesRequired: true,
  validate: (value, { config }) => {
    if (!config) return true;
    return config.isValid
  },
  message: (fieldName, placeholders) => {
    return `The ${fieldName} field must be valid phone number`;
  }
});

// Install messages
localize({
  en
});
